

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {FuseSidebarModule} from "../../../@fuse/components";
import {MatRippleModule} from "@angular/material/core";
import {ServiceMainSidebarComponent} from "./sidebars/main/main-sidebar.component";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatDialogModule} from "@angular/material/dialog";
import {MatToolbarModule} from "@angular/material/toolbar";
import {RouterModule} from "@angular/router";
import {ServiceComponent} from "./service.component";
import {MatTreeModule} from "@angular/material/tree";
import {TranslateModule} from "@ngx-translate/core";
import {ServiceFormComponent} from "./serviceForm.component";
import {ServiceDetailsComponent} from "./serviceDetails.component";
import {ServiceDetailsSidebarComponent} from "./sidebars/details/details-sidebar.component";
import {ServicesResolve} from "./services.resolve";
import {DeleteServiceDialogComponent} from "./dialog/deleteServiceDialog.component";
import {MatTabsModule} from "@angular/material/tabs";
import {GalleryModule} from "../cms/gallery/gallery.module";
import {ServiceResolve} from "./resolvers/service.resolve";

@NgModule({
    declarations: [
        ServiceComponent,
        ServiceMainSidebarComponent,
        ServiceDetailsSidebarComponent,
        ServiceFormComponent,
        ServiceDetailsComponent,
        DeleteServiceDialogComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDialogModule,
        MatToolbarModule,
        MatTreeModule,
        TranslateModule,
        MatTabsModule,
        GalleryModule
    ],
    providers: [
        ServicesResolve,
        ServiceResolve,
    ],
    bootstrap: [
        ServiceComponent,
        ServiceFormComponent,
        ServiceDetailsComponent,
        DeleteServiceDialogComponent,
    ]
})
export class ServiceModule { }
